// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"125":"a6b8d4ca","234":"bb7f9caf","353":"d7719a3c","594":"1c55e897"}[chunkId] + ".js";
};